import {RowProperties} from 'notebook/tables/constants/RowConstants';
import {
  computeHasUnsubmittedChanges,
  computeIsRowOutdated,
  computeIsTableRowTombstoned,
  computeTombstoneReasonTooltipForRow,
} from 'notebook/tables/store/logic/TableRowStatusLogic';
import {TableModel} from 'notebook/tables/store/models/TableModel';
import {createDebuggableSelector} from 'notebook/tables/store/selectors/util/SelectorCreators';
import {
  createTableEditableStoreStructuredSelector,
  TableEditableStore,
} from 'notebook/tables/store/TableStore';

export function createRowStatusSelector(
  tableSelector: (store: TableEditableStore) => TableModel,
  rowIndex: number
): (store: TableEditableStore) => RowProperties {
  return createTableEditableStoreStructuredSelector(
    {
      hasErrors: (store) => tableSelector(store).props.errorRows?.[rowIndex] === true,
      hasWarnings: (store) => tableSelector(store).props.warningRows?.[rowIndex] === true,
      hasUnsubmittedChanges: (store) => {
        const tableModel = tableSelector(store);
        return computeHasUnsubmittedChanges(
          tableModel.props.table,
          rowIndex,
          tableModel.context.isConfigTable
        );
      },
      isOutdated: (store) => {
        const tableModel = tableSelector(store);
        return computeIsRowOutdated(tableModel.props.staleRows, rowIndex);
      },
      archivePurpose: (store) => tableSelector(store).props.table.rowData?.[rowIndex]?.uiData?.archivePurpose,
      isTombstoned: (store) => {
        const tableModel = tableSelector(store);
        return computeIsTableRowTombstoned(tableModel.props.table, rowIndex);
      },
      tombstoneReasonTooltip: (store) => {
        const tableModel = tableSelector(store);
        return computeTombstoneReasonTooltipForRow(tableModel.props.table, rowIndex);
      },
      unsubmittedChangesTooltip: (store) =>
        tableSelector(store).props.table.rowData?.[rowIndex]?.uiData?.unsubmittedChangesTooltip,
    },
    createDebuggableSelector.withTypes<TableEditableStore>()
  );
}
